<template>
  <div :class="{ 'has-error': validacao.$error }" class="form-group">
    <label v-if="exibeLabel">
      {{ label }} <sup>{{ labelSup }}</sup>
    </label>
    <select
      :id="id"
      :data-test-id="`select-${id}`"
      :value="valorInterno"
      :name="id"
      :disabled="somenteLeitura"
      class="form-control"
      @change="atualizar($event.target)"
    >
      <option v-if="mostrarSelecione" value=""> Selecione </option>
      <option v-if="mostrarTodos" value="">Todas</option>
      <option
        v-for="u in unidades"
        :key="u[chave]"
        :selected="u[chave] === valorInterno"
        :value="u[chave]"
      >
        {{ u.nome }}
      </option>
    </select>
    <div v-if="validacao.$dirty" class="help-block">
      <slot name="mensagensValidacao" />
    </div>
  </div>
</template>

<script>
import { campoMixin } from '@/mixins/CampoMixin'
import UnidadeServico from '@/servicos/UnidadeServico'
const unidadeServico = new UnidadeServico()

export default {
  name: 'SelecionarUnidade',
  mixins: [campoMixin],
  props: {
    label: {
      type: String,
      default: 'Unidade',
    },
    id: {
      type: String,
      default: 'unidade',
    },
    mostrarTodos: {
      type: Boolean,
      default: true,
    },
    mostrarSelecione: {
      type: Boolean,
      default: false,
    },
    valorPadrao: {
      type: Boolean,
      default: false,
    },
    chave: {
      type: String,
      default: 'nome',
    },
  },
  data() {
    return {
      unidades: [],
    }
  },
  created() {
    this.recuperarUnidades()
  },
  methods: {
    recuperarUnidades() {
      unidadeServico.recuperarTodos().then((result) => {
        this.unidades = result.unidades

        if (this.valorPadrao) {
          this.atualizar({ value: this.unidades[0][this.chave] })
        }

        this.$emit('pronto', this.unidades)
      })
    },
  },
}
</script>
